import { action } from "../const";

let initialState = {
    userTeams: undefined,
}

export default function FamilyReducer(state = initialState, data) {

    switch (data.type) {

        case action.USER_TEAMS:
            return {
                ...state,
                userTeams: data.payload
            }

        default:
            break;
    }
    return state;
}